import "@/App.css";
import Cinematic from "./cinematic/Cinematic";
import {
  HowItWorks,
  StatBlock,
  QuoteBlock,
  Footer,
} from "./sections/Editorial";

const App = () => (
  <main className="site" data-testid="site-root">
    <Cinematic />
    <HowItWorks />
    <StatBlock />
    <QuoteBlock />
    <Footer />
  </main>
);

export default App;
